import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup as InMarkitRadioGroup,
  RadioGroupProps as InMarkitRadioGroupProps,
  Stack,
} from '@mui/material';
import React, { ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface RadioGroupProps extends InMarkitRadioGroupProps {
  name: string;
  options: { value: any; label: ReactNode; options?: any }[];
  normalizeOutput?: Function;
  normalizeInput?: Function;
  renderOption?: (option: { value: any; label: ReactNode; options?: any }) => ReactNode;
}

function RadioGroup({
  name,
  options,
  normalizeOutput = (event) => event,
  normalizeInput = (input) => input,
  renderOption,
  ...rest
}: RadioGroupProps) {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ control, name });

  const renderOptionDefault = ({ value, label }: { value: any; label: React.ReactNode }) => (
    <FormControlLabel key={value} value={value} label={label} control={<Radio />} />
  );

  return (
    <Stack>
      <InMarkitRadioGroup
        value={normalizeInput(field.value)}
        onChange={(event) => field.onChange(normalizeOutput(event))}
        onBlur={field.onBlur}
        row
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        {options.map(renderOption || renderOptionDefault)}
      </InMarkitRadioGroup>
      {error?.message && <FormHelperText error={!!error}>{error?.message ? error?.message : ` `}</FormHelperText>}
    </Stack>
  );
}

export default RadioGroup;
